<template>
  <v-app-bar app absolute prominent flat color="#ffffff">
    <v-row
      align="center"
      justify="space-between"
      no-gutters
      class="home-nav-row"
    >
      <div @click="$router.push({ name: 'SiteHome' })">
        <span class="brand">ges</span>
        <span class="brand-italic">kitchen</span>
      </div>
      <v-spacer></v-spacer>
      <v-row align="center" no-gutters v-show="$vuetify.breakpoint.smAndUp">
        <v-btn text class="mx-3" :to="{ name: 'Features' }" exact>
          <span class="font-capitalize font-weight-light">Fonctionnalités</span>
        </v-btn>
        <v-btn text class="mx-3" :to="{ name: 'Contact' }" exact>
          <span class="font-capitalize font-weight-light">Nous joindre</span>
        </v-btn>
      </v-row>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn outlined rounded :to="{ name: 'Login' }">
        <span class="font-capitalize font-weight-light" style="padding: 0 1rem;"
          >Connexion</span
        ></v-btn
      >
    </v-row>
  </v-app-bar>
</template>

<script>
export default {
  name: "SiteNav"
};
</script>

<style lang="scss" scoped>
.brand {
  cursor: pointer;
  font-weight: 800;
}
.brand-italic {
  cursor: pointer;
  font-weight: 900;
  font-family: "Merriweather", serif;
  font-style: italic;
  letter-spacing: -1px;
}
.home-nav-row {
  height: 100%;
  padding: 0;
}
@media screen and (min-width: 600px) {
  .home-nav-row {
    padding: 2rem;
  }
}
</style>
